module.exports = __webpack_public_path__ + "assets/lucky-wheel-info-icon-e902c0.png";